import Image from 'next/image';
import { useState } from 'react';
import { FaArrowDownLong } from 'react-icons/fa6';
const AndroidView = ({
  mode
}: {
  mode: 'safari' | 'chrome';
}) => {
  return <div className='ta-c' data-sentry-component="AndroidView" data-sentry-source-file="DownloadView.tsx">
      <p className='text-[12px] px-12 mt-6 text-genius-gradient-dark'>
        The App Store charges a 30% fees on all apps. Genius is a Progressive Web App (PWA) to keep
        fees 30% lower for you, the end user. Follow the steps below to add Genius to your home
        screen.
      </p>
      <div className='text-genius-cream text-2xl my-4'>1</div>
      <div className='mt-2 text-genius-gradient-dark text-sm z-20'>
        Tap the “Share” button in your {mode == 'safari' ? 'bottom navigation' : 'top right corner'}
      </div>
      <div>
        <Image src={mode == 'safari' ? '/static/images/pwaiphone-safari-0.png' : '/static/images/pwaiphone-chrome-0.png'} width={315} height={106} alt='step1' className='mt-2' data-sentry-element="Image" data-sentry-source-file="DownloadView.tsx" />
      </div>

      <div className='text-genius-cream text-2xl my-4'>2</div>
      <div className='mt-2 text-genius-gradient-dark text-sm z-20'>
        Then tap the “Add to Home Screen”
      </div>
      <div>
        <Image src='/static/images/download-android-2.png' width={266} height={106} alt='step2' className='mt-2' data-sentry-element="Image" data-sentry-source-file="DownloadView.tsx" />
        {mode == 'safari' && <FaArrowDownLong className='mt-8 w-[40px] h-[40px] text-genius-cream' />}
      </div>
    </div>;
};
const IosView = () => {
  return <div className='ta-c' data-sentry-component="IosView" data-sentry-source-file="DownloadView.tsx">
      <div className='text-genius-cream text-2xl my-4'>1</div>
      <div className='mt-2 text-genius-gradient-dark text-sm z-20'>
        Tap the “Menu” button in your broswer
      </div>
      <div>
        <Image src='/static/images/download-wuji.png' width={268} height={49} alt='step1' className='mt-2' data-sentry-element="Image" data-sentry-source-file="DownloadView.tsx" />
      </div>

      <div className='text-genius-cream text-2xl my-4'>2</div>
      <div className='mt-2 text-genius-gradient-dark text-sm z-20'>
        Tap “Install App” in the panel
      </div>
      <div>
        <Image src='/static/images/download-ios-2.png' width={261} height={46} alt='step2' className='mt-2' data-sentry-element="Image" data-sentry-source-file="DownloadView.tsx" />
      </div>

      <div className='text-genius-cream text-2xl my-4'>3</div>
      <div className='mt-2 text-genius-gradient-dark text-sm z-20'>Tap “Install” in the pop up</div>
      <div>
        <Image src='/static/images/download-ios-3.png' width={317} height={89} alt='step3' className='mt-2' data-sentry-element="Image" data-sentry-source-file="DownloadView.tsx" />
      </div>
    </div>;
};
export const DownloadView: React.FC = () => {
  const [switchView, setSwitchView] = useState<'iosSafari' | 'iosChrome' | 'android'>('iosSafari');
  console.log('switchView', switchView);
  return <div data-sentry-component="DownloadView" data-sentry-source-file="DownloadView.tsx">
      <div className='flex m-auto w-fit p-1 rounded-xl bg-genius-indigo border-genius-blue border-[1px] text-genius-cream h-10 gap-2 items-center mt-4'>
        <div className={`ta-c w-fit rounded-xl text-xs p-2 ${switchView == 'iosSafari' && 'bg-indigo-950'} px-3 cursor-pointer`} onClick={() => setSwitchView('iosSafari')}>
          iOS Safari
        </div>
        <div className={`ta-c w-fit rounded-xl text-xs p-2 ${switchView == 'iosChrome' && 'bg-indigo-950'} px-3 cursor-pointer`} onClick={() => setSwitchView('iosChrome')}>
          iOS Chrome
        </div>
        <div className={`ta-c w-fit rounded-lg text-xs p-2 ${switchView == 'android' && 'bg-indigo-950'} px-3 cursor-pointer`} onClick={() => setSwitchView('android')}>
          Android
        </div>
      </div>
      {switchView === 'iosSafari' && <AndroidView mode='safari' />}
      {switchView === 'iosChrome' && <AndroidView mode='chrome' />}
      {switchView === 'android' && <IosView />}
    </div>;
};